import { createContext } from 'react';

export const UseTitleContext = createContext('');
